import { Box } from './variants/Box/Box';
import { Circle } from './variants/Circle/Circle';
import { TextLine } from './variants/TextLine/TextLine';
import { TextBlock } from './variants/TextBlock/TextBlock';
import { Card } from './variants/Card/Card';
import { ProductCardSkeleton } from './variants/ProductCard/ProductCardSkeleton';
import { ImageSkeleton } from './variants/Image/ImageSkeleton';

export const LoadingSkeleton = {
  Box,
  Circle,
  TextLine,
  TextBlock,
  Card,
  ProductCardSkeleton,
  Image: ImageSkeleton,
};
